import QuickActions from './quick_actions';

export default QuickActions;
